/* ============
 * Patient Transformer
 * ============
 *
 * The transformer for the patient.
 */

import Transformer from './Transformer';
import _ from 'lodash';

export default class PatientTransformer extends Transformer {
  /**
   * Method used to transform a fetched patient.
   *
   * @param account The fetched account.
   *
   * @returns {Object} The transformed account.
   */
  static fetch(patient) {
    if (!_.isEmpty(patient)) {
      return {
        id: patient.id,
        first_name: patient.first_name,
        last_name: patient.last_name,
        mr_id: patient.mr_id,
        gender: patient.user.gender,
        dob: patient.user.dob,
        mobile_no: patient.user.mobile_no,
        email: patient.user.email,
        country_code: patient.user.country_code,
        user_id :patient.user_id,
      };
    }
  }

}
